import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Path } from '@s8l/client-tree-lib';

import { Journey, JourneyService } from 'src/app/services/journey.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-journey',
  templateUrl: './journey.component.html',
  styleUrls: ['./journey.component.scss']
})
export class JourneyComponent implements OnInit {
  public journeys: Journey[];
  public loading = false;

  constructor(private router: Router, private service: JourneyService, private notification: NotificationsService) {}

  ngOnInit() {
    return this.service.list().then(j => (this.journeys = j));
  }

  public navigate(uuid: string) {
    this.loading = true;
    return this.router.navigate(['/journey', uuid]).finally(() => (this.loading = false));
  }

  public parse(uri: string) {
    return Path.parse(uri);
  }

  public remove(journey: Journey, index: number) {
    this.loading = true;
    return this.service
      .delete(journey)
      .then(() => this.journeys.splice(index, 1))
      .then(() => this.notification.notify('success', 'Deleted', `The Journey was successfully deleted!`))
      .finally(() => (this.loading = false));
  }
}
